/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGetCurrentOrganizationResellersDto } from '../models/custom-result-of-list-of-get-current-organization-resellers-dto';
import { CustomResultOfListOfGetResellerUsersByOrganizationIdDto } from '../models/custom-result-of-list-of-get-reseller-users-by-organization-id-dto';
import { CustomResultOfListOfResellersListDto } from '../models/custom-result-of-list-of-resellers-list-dto';
import { CustomResultOfPaginatedListOfGetResellersWithPaginationByOrganizationIdDto } from '../models/custom-result-of-paginated-list-of-get-resellers-with-pagination-by-organization-id-dto';
import { CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto } from '../models/custom-result-of-paginated-list-of-resellers-with-pagination-by-user-id-dto';
import { CustomResultOfPaginatedListOfResellerWithPaginationDto } from '../models/custom-result-of-paginated-list-of-reseller-with-pagination-dto';
import { CustomResultOfResellerDto } from '../models/custom-result-of-reseller-dto';
import { resellersCreateGet } from '../fn/resellers/resellers-create-get';
import { ResellersCreateGet$Params } from '../fn/resellers/resellers-create-get';
import { resellersCreatePost } from '../fn/resellers/resellers-create-post';
import { ResellersCreatePost$Params } from '../fn/resellers/resellers-create-post';
import { resellersDelete } from '../fn/resellers/resellers-delete';
import { ResellersDelete$Params } from '../fn/resellers/resellers-delete';
import { resellersGetCurrentOrganizationResellers } from '../fn/resellers/resellers-get-current-organization-resellers';
import { ResellersGetCurrentOrganizationResellers$Params } from '../fn/resellers/resellers-get-current-organization-resellers';
import { resellersGetResellersAudit } from '../fn/resellers/resellers-get-resellers-audit';
import { ResellersGetResellersAudit$Params } from '../fn/resellers/resellers-get-resellers-audit';
import { resellersGetResellersList } from '../fn/resellers/resellers-get-resellers-list';
import { ResellersGetResellersList$Params } from '../fn/resellers/resellers-get-resellers-list';
import { resellersGetResellersWithPagination } from '../fn/resellers/resellers-get-resellers-with-pagination';
import { ResellersGetResellersWithPagination$Params } from '../fn/resellers/resellers-get-resellers-with-pagination';
import { resellersGetResellersWithPaginationByOrganizationId } from '../fn/resellers/resellers-get-resellers-with-pagination-by-organization-id';
import { ResellersGetResellersWithPaginationByOrganizationId$Params } from '../fn/resellers/resellers-get-resellers-with-pagination-by-organization-id';
import { resellersGetResellersWithPaginationByUserId } from '../fn/resellers/resellers-get-resellers-with-pagination-by-user-id';
import { ResellersGetResellersWithPaginationByUserId$Params } from '../fn/resellers/resellers-get-resellers-with-pagination-by-user-id';
import { resellersGetResellerUsersByOrganizationId } from '../fn/resellers/resellers-get-reseller-users-by-organization-id';
import { ResellersGetResellerUsersByOrganizationId$Params } from '../fn/resellers/resellers-get-reseller-users-by-organization-id';
import { resellersUpdateGet } from '../fn/resellers/resellers-update-get';
import { ResellersUpdateGet$Params } from '../fn/resellers/resellers-update-get';
import { resellersUpdatePut } from '../fn/resellers/resellers-update-put';
import { ResellersUpdatePut$Params } from '../fn/resellers/resellers-update-put';

@Injectable({ providedIn: 'root' })
export class ResellersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `resellersGetResellersAudit()` */
  static readonly ResellersGetResellersAuditPath = '/Resellers/GetResellersAudit';

  /**
   * Only for Pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetResellersAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersAudit$Response(params: ResellersGetResellersAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return resellersGetResellersAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for Pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetResellersAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersAudit(params: ResellersGetResellersAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.resellersGetResellersAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `resellersGetResellersWithPagination()` */
  static readonly ResellersGetResellersWithPaginationPath = '/Resellers/GetResellersWithPagination';

  /**
   * Get Resellers with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetResellersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersWithPagination$Response(params: ResellersGetResellersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfResellerWithPaginationDto>> {
    return resellersGetResellersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Resellers with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetResellersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersWithPagination(params: ResellersGetResellersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfResellerWithPaginationDto> {
    return this.resellersGetResellersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfResellerWithPaginationDto>): CustomResultOfPaginatedListOfResellerWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `resellersGetResellersWithPaginationByUserId()` */
  static readonly ResellersGetResellersWithPaginationByUserIdPath = '/Resellers/GetResellersWithPaginationByUserId';

  /**
   * Get Resellers By UserId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetResellersWithPaginationByUserId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersWithPaginationByUserId$Response(params: ResellersGetResellersWithPaginationByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto>> {
    return resellersGetResellersWithPaginationByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Resellers By UserId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetResellersWithPaginationByUserId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersWithPaginationByUserId(params: ResellersGetResellersWithPaginationByUserId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto> {
    return this.resellersGetResellersWithPaginationByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto>): CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto => r.body)
    );
  }

  /** Path part for operation `resellersGetResellersWithPaginationByOrganizationId()` */
  static readonly ResellersGetResellersWithPaginationByOrganizationIdPath = '/Resellers/GetResellersWithPaginationByOrganizationId';

  /**
   * Get Resellers By OrganizationId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetResellersWithPaginationByOrganizationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersWithPaginationByOrganizationId$Response(params: ResellersGetResellersWithPaginationByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetResellersWithPaginationByOrganizationIdDto>> {
    return resellersGetResellersWithPaginationByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Resellers By OrganizationId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetResellersWithPaginationByOrganizationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellersWithPaginationByOrganizationId(params: ResellersGetResellersWithPaginationByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetResellersWithPaginationByOrganizationIdDto> {
    return this.resellersGetResellersWithPaginationByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetResellersWithPaginationByOrganizationIdDto>): CustomResultOfPaginatedListOfGetResellersWithPaginationByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `resellersCreateGet()` */
  static readonly ResellersCreateGetPath = '/Resellers/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersCreateGet$Response(params?: ResellersCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return resellersCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersCreateGet(params?: ResellersCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.resellersCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `resellersCreatePost()` */
  static readonly ResellersCreatePostPath = '/Resellers/Create';

  /**
   * Create Reseller.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersCreatePost$Response(params: ResellersCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return resellersCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Reseller.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersCreatePost(params: ResellersCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.resellersCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `resellersUpdateGet()` */
  static readonly ResellersUpdateGetPath = '/Resellers/Update';

  /**
   * Get Reseller by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersUpdateGet$Response(params?: ResellersUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfResellerDto>> {
    return resellersUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersUpdateGet(params?: ResellersUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfResellerDto> {
    return this.resellersUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfResellerDto>): CustomResultOfResellerDto => r.body)
    );
  }

  /** Path part for operation `resellersUpdatePut()` */
  static readonly ResellersUpdatePutPath = '/Resellers/Update';

  /**
   * Update Reseller.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersUpdatePut$Response(params: ResellersUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return resellersUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Reseller.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersUpdatePut(params: ResellersUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.resellersUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `resellersDelete()` */
  static readonly ResellersDeletePath = '/Resellers/{id}';

  /**
   * Delete Reseller.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersDelete$Response(params: ResellersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return resellersDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Reseller.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersDelete(params: ResellersDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.resellersDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `resellersGetResellersList()` */
  static readonly ResellersGetResellersListPath = '/Resellers/GetResellersList';

  /**
   * Get Resellers List for drop down.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetResellersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersGetResellersList$Response(params?: ResellersGetResellersList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfResellersListDto>> {
    return resellersGetResellersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Resellers List for drop down.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetResellersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersGetResellersList(params?: ResellersGetResellersList$Params, context?: HttpContext): Observable<CustomResultOfListOfResellersListDto> {
    return this.resellersGetResellersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfResellersListDto>): CustomResultOfListOfResellersListDto => r.body)
    );
  }

  /** Path part for operation `resellersGetResellerUsersByOrganizationId()` */
  static readonly ResellersGetResellerUsersByOrganizationIdPath = '/Resellers/GetResellerUsersByOrganizationId';

  /**
   * دریافت لیست فروشندگان بر اساس شناسه سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetResellerUsersByOrganizationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellerUsersByOrganizationId$Response(params: ResellersGetResellerUsersByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetResellerUsersByOrganizationIdDto>> {
    return resellersGetResellerUsersByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست فروشندگان بر اساس شناسه سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetResellerUsersByOrganizationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellersGetResellerUsersByOrganizationId(params: ResellersGetResellerUsersByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetResellerUsersByOrganizationIdDto> {
    return this.resellersGetResellerUsersByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetResellerUsersByOrganizationIdDto>): CustomResultOfListOfGetResellerUsersByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `resellersGetCurrentOrganizationResellers()` */
  static readonly ResellersGetCurrentOrganizationResellersPath = '/Resellers/GetCurrentOrganizationResellers';

  /**
   * دریافت لیست فروشندگان سازمان فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellersGetCurrentOrganizationResellers()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersGetCurrentOrganizationResellers$Response(params?: ResellersGetCurrentOrganizationResellers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentOrganizationResellersDto>> {
    return resellersGetCurrentOrganizationResellers(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست فروشندگان سازمان فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellersGetCurrentOrganizationResellers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellersGetCurrentOrganizationResellers(params?: ResellersGetCurrentOrganizationResellers$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentOrganizationResellersDto> {
    return this.resellersGetCurrentOrganizationResellers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentOrganizationResellersDto>): CustomResultOfListOfGetCurrentOrganizationResellersDto => r.body)
    );
  }

}
